import { ConfigResolver } from '../../loader/essentials/config-resolver.js';
import { Registry } from '../../loader/registry.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

export const HEIGHT_ANIMATION_CHANGE: EffectFunction = ({ adserverAnchor }: Adslot) => {
    const { animationDuration = 2 } = Registry.lookup<ConfigResolver>('ConfigResolver').getLayoutSettings();
    adserverAnchor.style.transitionProperty = 'height, min-height';
    adserverAnchor.style.transitionDuration = `${animationDuration}s`;
    return () => {
        adserverAnchor.style.transitionProperty = '';
        adserverAnchor.style.transitionDuration = '';
    };
};
